import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from './auth'
import router from '../router'

const request = axios.create({
  baseURL: '/api/admin',
  timeout: 15000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['access_token'] = token
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    // 后端消息转换器将Long转为String，需将total转为数字供分页组件使用
    if (res.data && typeof res.data.total === 'string') {
      res.data.total = Number(res.data.total)
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      removeToken()
      Message.error('登录已过期，请重新登录')
      router.push('/login')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default request
